module.exports = __webpack_public_path__ + "img/CtrlRoom_BT_off.1736778b.png";